export default {
    WAS_INSTALLATION_GUIDE_SHOWN: 'was_installation_guide_shown',
    MODE_TYPE: 'mode',
    AGE_GATE: 'AGE_GATE',
    IS_GET_STARTED_PAGE_SHOWN: 'IS_GET_STARTED_PAGE_SHOWN',
    WAS_SETUP_GUIDE_SHOWN: 'was_setup_guide_shown',
    LANGUAGE_CODE: 'language_code',
    COUNTRY_CODE: 'country_code',
    API_COUNTRY_CODE: 'api_country_code',
    IS_SYSTEM_LANGUAGE_ENABLED: 'is_system_language_enabled',
    THEME: 'theme',
    IS_INITIAL_SETUP_COMPLETED: 'is_initial_setup_completed',
    APP_LOG_STREAM_UUID: 'APP_LOG_STREAM_UUID',
    SUBSCRIPTION_LANGUAGE_CODE: 'SUBSCRIPTION_LANGUAGE_CODE',
    SUBSCRIPTION_NOTIFICATION_TYPES: 'SUBSCRIPTION_NOTIFICATION_TYPES',
    SUBSCRIPTION_PERMISSION: 'SUBSCRIPTION_PERMISSION',
    SUBSCRIPTION_PUBLIC_KEY: 'SUBSCRIPTION_PUBLIC_KEY',
    IS_SUBSCRIPTION_UNSUBSCRIBED: 'IS_SUBSCRIPTION_UNSUBSCRIBED',
    DISABLED_NOTIFICATION_TYPES: 'DISABLED_NOTIFICATION_TYPES',
    IS_EXPERIENCE_CONSENTS_ACCEPTED: 'IS_EXPERIENCE_CONSENTS_ACCEPTED',
    IS_USAGE_CONSENTS_ACCEPTED: 'IS_USAGE_CONSENTS_ACCEPTED',
    IS_AD_CONSENTS_ACCEPTED: 'IS_AD_CONSENTS_ACCEPTED',
    SWITCH_MASTER_QUIZ_STATUS: 'SWITCH_MASTER_QUIZ_STATUS',
    IS_CLUB_HIGHLIGHTS_WATCHED: 'IS_CLUB_HIGHLIGHTS_WATCHED',
    IS_HIGHLIGHTS_AND_QUIZ_WATCHED: 'IS_HIGHLIGHTS_AND_QUIZ_WATCHED',
    CREDENTIALS_POPUP_HIDDEN: 'CREDENTIALS_POPUP_HIDDEN',
    BROWSER_CHECK: 'BROWSER_CHECK',
    GEO_RESTRICTION: 'gr',
    IS_CONVERSION_START_TIP_HIDDEN: 'IS_CONVERSION_START_TIP_HIDDEN',
    IS_CONVERSION_RESTART_TIP_HIDDEN: 'IS_CONVERSION_RESTART_TIP_HIDDEN',
    COMPLETION_MESSAGE_QUEUE: 'COMPLETION_MESSAGE_QUEUE',
    SHOWN_FEEDBACK_FEATURES: 'SHOWN_FEEDBACK_FEATURES',
    IS_VISIBILITY_RECONNECT_DISABLED: 'IS_VISIBILITY_RECONNECT_DISABLED',
    DEVICE_KIT_MAP: 'DEVICE_KIT_MAP',
    DEVICE_SYNC_DATE_MAP: 'DEVICE_SYNC_DATE_MAP',
    ANALYTICS_SESSION_ID: 'ANALYTICS_SESSION_ID',
    EC_FLOW: 'EC_FLOW',
    EC_PUSHES: 'EC_PUSHES',
    VOXLINK_SESSION: 'VOXLINK_SESSION',
};
